import React from 'react'
import { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import { useGetAddressByNameQuery } from '../../../../store/api/address';
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1";
import Tab2 from './Tab2';
import Attachment from '../../../../utils/Attachment';
function Address() {
    const location = useLocation()
    const [apidata, setapidata] = useState('')
    const addressId = location?.state?.addressName
    const [tab, settab] = useState(1)
    const [error, setError] = useState('');
    const [ptype, setptype] = useState("Error")
    const [showError, setShowError] = useState(false);
    const { data: addressdata, adderror, isLoading } = useGetAddressByNameQuery(addressId);
    const [isyca, setyca] = useState(0)
    const [status, setStatus] = useState(false)
    useEffect(() => {
        if (addressdata) {
            setapidata(addressdata?.data)
        }
    }, [addressdata])



    const [formdata, setFormData] = useState({
        addressTitle: '',
        AddressType: '',
        AddressLine1: '',
        AddressLine2: '',
        Country: '',
        City: '',
        State: '',
        postalCode: '',
        email: '',
        phone: '',
        Fax: '',
        taxCategory: '',
        pba: false,
        psa: false,
        Disabled: false,
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };


    return (
        <>
            <FormLayout
                title="View Address"
                breadcrumbs={[
                    { label: "Address" },
                    { label: "Address List", url: "/master/address/address-list" }
                ]}
                 status={'hide'}
                actionButtons={
                    <>
                        <Button
                            to="/brand/create-brand"
                            className="px-2"
                            imgSrc={printerimg}
                            imgStyle={{ width: '21px' }}
                        />
                    </>
                }
            >
                <div className="" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                    <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                        <div className="d-flex justify-content-between align-items-end ">
                            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                                    <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                                        General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                    </a>
                                </li>
                            </ul>
                            <Attachment doctype="Address"  docname={addressId}  />    
                        </div>
                    </div>
                    <div className="mt-2 py-2" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                        <div className="row d-flex justify-content-between">
                            <div className="col-12" >
                                <div className="sidebarbox m-0 px-4 py-2">
                                    <Tab1 formdata={formdata} handleChange={handleChange} setFormData={setFormData} apidata={apidata} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-2 py-2" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                        <div className="row d-flex justify-content-between">
                            <div className="col-12" >
                                <div className="sidebarbox m-0 px-4 py-2">
                                    <Tab2 apidata={apidata} isyca={isyca} setyca={setyca} addressId={addressId} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </FormLayout>
        </>
    )
}

export default Address
